import { stringToArrayModel } from "./stringToArrayModel.js";
import * as z from "zod";
//#region src/models/globalFilterParamModel.ts
/**
* Multi-select ID filters shared with the global-filter-bar (see `FilterOptions` in
* packages/app/src/providers/globalFiltersConfig.ts) — reusable across list endpoints that filter
* by deployment, assignee, device or device model.
*
* deviceTagIds is matched against a device's tag or any ancestor of it (see
* getDeviceTagDescendantIds) — an entity matches if any of its devices carries one of these tags,
* or a descendant tag.
*/
const globalFilterParamModel = z.object({
	deploymentIds: stringToArrayModel(z.string().array().nonempty().optional()),
	assigneeIds: stringToArrayModel(z.string().array().nonempty().optional()),
	deviceTagIds: stringToArrayModel(z.string().array().nonempty().optional()),
	deviceIds: stringToArrayModel(z.string().array().nonempty().optional()),
	deviceModelIds: stringToArrayModel(z.string().array().nonempty().optional())
});
//#endregion
export { globalFilterParamModel };
